module.exports = __webpack_public_path__ + "static/react-motion-8ce079a452baec9a583d60285fe0531f.gif";